<template>
  <div class="number-keyboard">
    <div v-for="(row, index) in keys" :key="index" class="row">
      <div v-for="key in row" :key="key" class="number-keyboard__key" :class="key" @click="clickHandler(key)">
        <span v-if="key === 'clear'">
          <Icons variant="close" />
        </span>
        <span v-else-if="key === 'remove'">
          <Icons variant="remove" />
        </span>
        <span v-else>
          {{ key }}
        </span>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import Icons from '@/components/UI/Icons/';

type KeyboardKey = string | number;

const props = defineProps<{
    modelValue?: string
}>();

const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void
    (e: 'onClear'): void
}>();

const keys: KeyboardKey[][] = [
    [1, 2, 3],
    [4, 5, 6],
    [7, 8, 9],
    ['clear', 0, 'remove']
];

function clickHandler(key: KeyboardKey) {
    let value = props.modelValue || '';
    switch (key) {
        case 'remove':
            value = value.slice(0, -1);
            break;
        case 'clear':
            value = '';
            emit('onClear');
            break;
        default:
            value += key;
    }
    emit('update:modelValue', value);
}
</script>
<style scoped lang="scss">
.number-keyboard {
    display: flex;
    flex-direction: column;
    gap: 26px;

    & .row {
        display: grid;
        grid-template-columns: repeat(3, 80px);
        grid-column-gap: 40px;
    }

    &__key {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 80px;
        height: 80px;
        font-size: 22px;
        font-weight: 700;
        color: var(--color-green);
        box-shadow: 1px 3px 25px 0 #002D1D1A;
        border-radius: 10px;

        &:active {
            background: var(--color-light-green);
        }

        &.clear,
        &.remove {
            background: var(--color-light-green);

            &:active {
                color: var(--color-white);
                background: var(--color-green);
            }
        }
    }
}
</style>